/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_Compare_ColInputs */

const en_mk_foot_compare_col = /** @type {(inputs: Mk_Foot_Compare_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare`)
};

const id_mk_foot_compare_col = /** @type {(inputs: Mk_Foot_Compare_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan`)
};

/**
* | output |
* | --- |
* | "Compare" |
*
* @param {Mk_Foot_Compare_ColInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_compare_col = /** @type {((inputs?: Mk_Foot_Compare_ColInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_Compare_ColInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_compare_col(inputs)
	return en_mk_foot_compare_col(inputs)
});